import { request } from './client';

// Public list (used by storefront — kept here for re-use if admin previews).
export const apiGetBlogPosts = () => request('/blog');

// Admin
export const apiAdminGetBlogPosts = () => request('/blog/admin/all');
export const apiAdminGetBlogPost = (id) => request(`/blog/admin/${id}`);
export const apiCreateBlogPost = (data) => request('/blog', { method: 'POST', body: data });
export const apiUpdateBlogPost = (id, data) =>
  request(`/blog/${id}`, { method: 'PUT', body: data });
export const apiToggleBlogPost = (id) =>
  request(`/blog/${id}/toggle`, { method: 'PUT' });
export const apiDeleteBlogPost = (id) =>
  request(`/blog/${id}`, { method: 'DELETE' });
